<template>
  <div>
    <b-button size="sm" variant="primary" v-b-modal.add-report class="text-nowrap">
      + Add Report
    </b-button>
    <AddReportTabs @added="onAdd"></AddReportTabs>
  </div>
</template>

<script>
import AddReportTabs from '@/xvisor/components/report/AddReportTabs.vue';

export default {
  components: {
    AddReportTabs,
  },
  methods: {
    onAdd(reportData) {
      this.$emit('added', reportData);
    },
  },
};
</script>
